import { render, staticRenderFns } from "./DebtInstallmentBillPagination.vue?vue&type=template&id=215ad64c"
import script from "./DebtInstallmentBillPagination.vue?vue&type=script&lang=js"
export * from "./DebtInstallmentBillPagination.vue?vue&type=script&lang=js"
import style0 from "./DebtInstallmentBillPagination.vue?vue&type=style&index=0&id=215ad64c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports